import React from 'react';
import { useParams } from 'react-router-dom';
import AdminCrudPage from './AdminCrudPage';
import AdminProfileSettings from './AdminProfileSettings';

const AdminModulePage = () => {
  const { resourceKey } = useParams();

  if (resourceKey === 'profile-settings') {
    return <AdminProfileSettings />;
  }

  return <AdminCrudPage />;
};

export default AdminModulePage;
